"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import * as b from "react";
import { useTheme as v } from "./hooks.js";
import { vars as B } from "./skins/skin-contract.css-mistica.js";
import { barBackground as S, bar as $, inverse as x, normal as y, progressBarSteppedContainer as N } from "./progress-bar.css-mistica.js";
import { getPrefixedDataAttributes as C } from "./utils/dom.js";
import P from "classnames";
import w from "./inline.js";
const R = (param)=>{
    let { progressPercent: e, color: s, "aria-label": p, "aria-labelledby": n, "aria-hidden": t, dataAttributes: c, reverse: l = !1 } = param;
    const { texts: m } = v(), a = Math.max(0, Math.min(100, e)), i = t && t !== "false" ? {
        "aria-hidden": t
    } : {
        role: "progressbar",
        "aria-valuenow": a,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": n ? void 0 : (()=>`${p || m.loading}, ${a}% ${m.progressBarCompletedLabel}`)(),
        "aria-labelledby": n
    };
    return /* @__PURE__ */ o("div", _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, C(c, "ProgressBar")), {
        className: S
    }), i), {
        children: /* @__PURE__ */ o("div", {
            className: P($, l ? x : y),
            style: {
                maxWidth: `${a}%`,
                backgroundColor: s !== null && s !== void 0 ? s : B.colors.controlActivated
            }
        })
    }));
}, T = (param)=>{
    let { steps: e, currentStep: s = 0, color: p, dataAttributes: n, "aria-label": t, "aria-labelledby": c, "aria-hidden": l } = param;
    const { texts: m } = v(), [a, g] = b.useState(Math.ceil(s)), [i, k] = b.useState(!1);
    b.useEffect(()=>{
        const r = Math.ceil(s);
        a !== r && (k(r < a), g(r));
    }, [
        s,
        e,
        a
    ]);
    const A = l && l !== "false" ? {
        "aria-hidden": l
    } : {
        role: "progressbar",
        "aria-valuenow": a,
        "aria-valuemin": 0,
        "aria-valuemax": e,
        "aria-label": c ? void 0 : (()=>{
            const r = m.progressBarStepLabel.replace("1$s", String(a)).replace("2$s", String(e));
            return t ? `${t}, ${r.toLowerCase()}` : r;
        })(),
        "aria-labelledby": c
    };
    return /* @__PURE__ */ o("div", _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, C(n, "ProgressBarStepped")), {
        role: "progressbar"
    }), A), {
        className: N,
        children: /* @__PURE__ */ o(w, {
            space: 8,
            fullWidth: !0,
            children: Array.from({
                length: e
            }, (r, d)=>{
                const u = d === a, h = d < a, f = d === a - 1;
                return /* @__PURE__ */ o("div", {
                    className: S,
                    "aria-hidden": "true",
                    children: (h || u) && /* @__PURE__ */ o("div", {
                        className: P($, {
                            [y]: f && !i,
                            [x]: u && i
                        }),
                        style: {
                            backgroundColor: p !== null && p !== void 0 ? p : B.colors.controlActivated,
                            maxWidth: h || f && !i ? "100%" : "0"
                        }
                    })
                }, d);
            })
        })
    }));
};
export { R as ProgressBar, T as ProgressBarStepped };
